import styled from "styled-components";
import { breakpoints } from "src/styles/styleUtils";
import { IoLockClosedOutline } from "react-icons/io5";

const LockedCategoryContainer = styled.div`
  position: absolute;
  background: #c62020;
  color: #fff;
  top: -27px;
  left: -13px;
  display: inline-block;
  font-weight: 900;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 35px;
  width: 35px;
  border-radius: 100px;
  transform: translateY(10px);
  z-index: 9;
  font-size: 20px;

  p {
    margin: 0 !important;
    font-size: 12px;
    transform: translateY(1px);
  }

  .tooltip {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    color: #fff;
    height: 35px;
    width: 35px;
    text-transform: none;
  }

  .tooltip:before,
  .tooltip:after {
    position: absolute;
    content: "";
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 10;
  }

  .tooltip:before {
    border-width: 20px 15px 0 15px;
    border-style: solid;
    border-color: #ebebeb transparent transparent transparent;
    top: -20px;
    z-index: 10;
  }

  .tooltip:hover:after {
    display: flex;
    justify-content: center;
    align-items: center;
    content: attr(data-tooltip);
    background: #ebebeb;
    width: 300px;
    height: 130px;
    font-size: 13px;
    color: #000000;
    font-weight: 300;
    top: -150px;
    left: -40px;
    padding: 20px;
    text-align: center;
    border-radius: 8px;
    letter-spacing: 1px;
    transform: translateY(20px);
    z-index: 10;

    @media (max-width: ${breakpoints.mobile}) {
      width: 275px;
    }
  }

  .tooltip:hover::before,
  .tooltip:hover::after {
    opacity: 1;
    transform: translateY(-2px);
  }

  @media (max-width: ${breakpoints.mobile}) {
    top: -25px;
    left: -15px;
  }
`;

export default function LockedCategory() {
  const tooltipDescription =
    "Roster creation will open again at the conclusion of the round. Prizes are available for the highest scoring roster in every round!";

  return (
    <LockedCategoryContainer>
      <span className="tooltip" data-tooltip={tooltipDescription}>
        <IoLockClosedOutline />
      </span>
    </LockedCategoryContainer>
  );
}
